var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.readonly || _vm.disabled
        ? _c("v-text-field", {
            attrs: {
              slot: "activator",
              label: _vm.label,
              value: _vm.formattedValue,
              "error-messages": _vm.errorMessages,
              name: _vm.id,
              "data-testid": _vm.testId,
              "persistent-hint": "",
              "prepend-icon": "event",
              readonly: _vm.readonly,
              disabled: _vm.disabled
            },
            slot: "activator"
          })
        : _c(
            "v-menu",
            {
              staticClass: "menu",
              attrs: {
                "close-on-content-click": false,
                "nudge-right": 40,
                transition: "scale-transition",
                "offset-y": "",
                "max-width": "290px",
                "min-width": "290px"
              },
              model: {
                value: _vm.isOpen,
                callback: function($$v) {
                  _vm.isOpen = $$v
                },
                expression: "isOpen"
              }
            },
            [
              _c("v-text-field", {
                ref: _vm.myRef,
                attrs: {
                  slot: "activator",
                  label: _vm.label,
                  value: _vm.formattedValue,
                  "error-messages": _vm.errorMessages,
                  name: _vm.id,
                  "data-testid": _vm.testId,
                  "persistent-hint": "",
                  "prepend-icon": "event",
                  readonly: "",
                  disabled: _vm.disabled
                },
                slot: "activator"
              }),
              _c("v-date-picker", {
                attrs: {
                  value: _vm.vuetifyFormattedValue,
                  "first-day-of-week": "1",
                  locale: "es-cl",
                  scrollable: "",
                  type: _vm.type,
                  max: _vm.max,
                  min: _vm.min
                },
                on: { input: _vm.handleChange }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }